import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import Chip from "@mui/material/Chip";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import authorsTableData from "./table-data";

// Redux and API
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../../redux/Reducers/GlobalReducer/globalSlice";
import { useSnackbarContext } from "components/SnackBarContext";
import { API_FAIL_MESSAGE, SUCCESS } from "constants/apiConstants";
import { API_ENDPOINTS } from "constants/apiConstants";
import api from "services/api";

function Broker() {
  const [tableData, setTableData] = useState([]);
  const [communityData, setCommunityData] = useState([]);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [selectedCommunities, setSelectedCommunities] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    data: null,
  });
  const auth = useSelector((state) => state.auth);
  const { IsLoginData } = auth;
  const tableName = "Broker";
  const dispatch = useDispatch();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbarContext();

  useEffect(() => {
    getTableData();
    getCommunityData();
  }, []);
  const getTableData = async () => {
    try {
      dispatch(setLoading(true));
      const response = await api.get(API_ENDPOINTS.GET_BROKERS);
      console.log(`GET ${tableName}`, response);
      dispatch(setLoading(false));
      const { status, data, message } = response.data;
      if (status === SUCCESS) {
        setTableData(data);
      } else {
        showErrorSnackbar(message);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Get ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };
  const getCommunityData = async () => {
    try {
      dispatch(setLoading(true));
      const response = await api.get(API_ENDPOINTS.GET_COMMUNITIES);
      dispatch(setLoading(false));
      const { status, data, message } = response.data;
      if (status === SUCCESS) {
        setCommunityData(data);
      } else {
        showErrorSnackbar(message);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Get ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };

  const handleAddNew = () => {
    setEditingItem(null);
    setName("");
    setEmail("");
    setPhone("");
    setSelectedCommunities([]);
    setIsActive(true);
    setOpen(true);
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setName(item.name || "");
    setEmail(item.email || "");
    setPhone(item.mobile || "");
    const matchedCommunities = communityData.filter((community) =>
      (item.communityname_list || []).includes(community.community_id)
    );
    setSelectedCommunities(matchedCommunities);
    setIsActive(!!item.isactive);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setName("");
    setEmail("");
    setPhone("");
    setSelectedCommunities([]);
    setIsActive(true);
    setEditingItem(null);
  };

  const handleSubmit = async () => {
    const payload = {
      login: email,
      passwd: "",
      name: name,
      surname: "",
      email: email,
      birthDate: "string",
      mobile: phone,
      sex: "M",
      communityname_list: selectedCommunities.map((c) => c.community_id),
    };
    try {
      dispatch(setLoading(true));
      let response;
      if (editingItem) {
        payload.idUser = editingItem.idUser;
        response = await api.post(API_ENDPOINTS.UPDATE_BROKER, payload);
      } else {
        response = await api.post(API_ENDPOINTS.CREATE_BROKER, payload);
      }

      const { status, message } = response.data;
      dispatch(setLoading(false));

      if (status === SUCCESS) {
        showSuccessSnackbar(
          message ||
            (editingItem
              ? `Updated ${tableName} successfully`
              : `Created ${tableName} successfully`)
        );
        handleClose();
        getTableData();
      } else {
        showErrorSnackbar(message || API_FAIL_MESSAGE);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Submit ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };
  const handleDelete = (item) => {
    setConfirmDialog({ open: true, data: item });
  };
  const performDelete = async (item) => {
    try {
      dispatch(setLoading(true));
      // console.log("Delete Req::", `${API_ENDPOINTS.DELETE_BROKER}${item.accountId}`);
      const response = await api.delete(
        `${API_ENDPOINTS.DELETE_BROKER}${item.idUser}`
      );
      // console.log("Delete Response::", response);
      const { status, message } = response.data;
      dispatch(setLoading(false));

      if (status === SUCCESS) {
        showSuccessSnackbar(message || "Broker deleted successfully");
        getTableData();
      } else {
        showErrorSnackbar(message || API_FAIL_MESSAGE);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Delete ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };
  const { columns, rows } = authorsTableData(
    tableData,
    handleEdit,
    handleDelete
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  {tableName}
                </MDTypography>
                <Button
                  variant="contained"
                  color="white"
                  startIcon={<Icon>add</Icon>}
                  onClick={handleAddNew}
                >
                  Add New
                </Button>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  // showTotalEntries={false}
                  // noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}

      {/* Add/Edit Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>
          {editingItem ? `Edit ${tableName}` : `Add New ${tableName}`}
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            fullWidth
            label="Name"
            margin="normal"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            fullWidth
            label="Email"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={!!editingItem}
          />
          <TextField
            fullWidth
            label="Phone No"
            margin="normal"
            value={phone}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d{0,10}$/.test(value)) {
                setPhone(value);
              }
            }}
            inputProps={{ maxLength: 10 }}
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Community</InputLabel>
            <Select
              multiple
              value={selectedCommunities}
              onChange={(e) => setSelectedCommunities(e.target.value)}
              input={<OutlinedInput label="Community" />}
              renderValue={(selected) => (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {selected.map((value) => (
                    <Chip
                      key={value.community_id}
                      label={value.communityname}
                    />
                  ))}
                </div>
              )}
              sx={{
                minHeight: "40px", // Ensure a minimum height for consistent dropdown height
                padding: "10px", // Adjust padding for better spacing
              }}
            >
              {communityData.map((community) => (
                <MenuItem key={community.community_id} value={community}>
                  {community.communityname}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* <FormControlLabel
            control={<Switch checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />}
            label="Active"
          /> */}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            style={{ color: "#fff" }}
            variant="contained"
            onClick={handleSubmit}
          >
            {editingItem ? "Update" : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Confirmation Dialog - moved outside */}
      <Dialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ open: false, data: null })}
        aria-labelledby="delete-confirm-title"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            padding: "1rem",
            minWidth: "400px",
          },
        }}
      >
        <DialogTitle
          id="delete-confirm-title"
          sx={{ fontWeight: "bold", textAlign: "center" }}
        >
          Delete Broker
        </DialogTitle>
        <DialogContent
          sx={{
            textAlign: "center",
            padding: "1rem",
            fontSize: "1rem",
            color: "text.secondary",
          }}
        >
          Are you sure you want to delete this broker?
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", paddingBottom: "1rem" }}>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              performDelete(confirmDialog.data);
              setConfirmDialog({ open: false, data: null });
            }}
          >
            Yes, Delete
          </Button>
          <Button
            variant="contained"
            color="inherit"
            onClick={() => setConfirmDialog({ open: false, data: null })}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Broker;
